import {
  isMallIOS,
  isMallAndroid,
  isMCMallCirculationAndroid,
  isMCMallCirculationIOS,
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform.js'
import Url from '@mc/mc-utils/js/url/url'

import { isMeicaiHarmony } from './get_app_info'

const checkWeChatKfGray = weChatKfGray => {
  // eslint-disable-next-line eqeqeq
  return Number(weChatKfGray) == 1
}

export const getWechatGray = (appInfo, miniProgramEnv) => {
  const url = new Url(window.location.href)
  const query = url.parseQuerystring()
  const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
  if (
    isMallIOS() ||
    isMallAndroid() ||
    isMCMallCirculationIOS() ||
    isMCMallCirculationAndroid() ||
    isMCMallKeyCustomerIOS() ||
    isMCMallKeyCustomerAndroid() ||
    isMeicaiHarmony()
  ) {
    return checkWeChatKfGray(appInfo.weChatKfGray)
  }
  if (miniProgramEnv.isMiniProgram) {
    const weChatKfGray = query.weChatKfGray || hashQuery.weChatKfGray || 0
    return checkWeChatKfGray(weChatKfGray)
  }
  const weChatKfGray = query.weChatKfGray || hashQuery.weChatKfGray || 0
  return checkWeChatKfGray(weChatKfGray)
}
